import React, { useEffect } from "react";
import { Col, FormGroup, Label, Row, Button } from "reactstrap";
import Select from "react-select";
import { Formik, Form } from "formik";

export default function SyncModal({
    YearList = [],
    ClassList = [],
    QuarterList = [],
    initialValues = {},
    onSubmit = () => { },
    onCancel = () => { },
    syncRebateClass = () => { },
    getClassRequest
}) {
    const quarterOptions = [ "Q1", "Q2", "Q3", "Q4"].map((data) => ({
                value: data,
                label: data,
            }));
    const starters = {
        year: initialValues.year || null,
        classIds:
            initialValues.classIds?.length > 0
                ? initialValues.classIds
                : initialValues.classId
                    ? [initialValues.classId]
                    : [],
        quarter: initialValues.quarter || null,
    };
    const [selectedYear, setSelectedYear] = React.useState(initialValues.year || null);
 useEffect(() => {
    if (selectedYear) {
      getClassRequest({
        rebateYear: selectedYear|| "",
      });
    }

  }, [selectedYear]);
    return (
        <Formik
            enableReinitialize
            initialValues={starters}
            validate={(values) => {
                const errors = {};
                if (!values.year) {
                    errors.year = "Required";
                }
                if (!values.classIds || values.classIds.length === 0) {
                    errors.classIds = "Required";
                }
                if (!values.quarter) {
                    errors.quarter = "Required";
                }
                return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
                onSubmit(values);
                setSubmitting(false);
            }}
        >
            {({ values, setFieldValue, handleSubmit, isSubmitting, errors, touched, isValid }) => (
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="4" className="no-floating-label">
                            <FormGroup className="mb-2">
                                <Select
                                    id="year"
                                    name="year"
                                    className="form-control selectbox"
                                    menuPlacement="auto"
                                    options={YearList}
                                    value={YearList?.find((d) => d.value === values.year) || null}
                                    onChange={(selectedOption) => {
                                        setFieldValue("year", selectedOption?.value || null);
                                        setSelectedYear(selectedOption?.value || null);
                                    }}
                                    isClearable
                                />
                                <Label className="form-label" htmlFor="year">
                                    Year
                                </Label>
                                {errors.year && touched.year && (
                                    <div className="text-danger mt-1">{errors.year}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md="4" className="no-floating-label">
                            <FormGroup className="mb-2">
                                <Select
                                    id="quarter"
                                    name="quarter"
                                    className="form-control selectbox"
                                    menuPlacement="auto"
                                    options={quarterOptions}
                                    value={quarterOptions?.find((d) => d.value === values.quarter) || null}
                                    onChange={(selectedOption) => {
                                        setFieldValue("quarter", selectedOption?.value || null);
                                    }}
                                    isClearable
                                />
                                <Label className="form-label" htmlFor="quarter">
                                    Quarter
                                </Label>
                                {errors.quarter && touched.quarter && (
                                    <div className="text-danger mt-1">{errors.quarter}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md="4" className="no-floating-label">
                            <FormGroup className="mb-2">
                                <Select
                                    id="classIds"
                                    name="classIds"
                                    className="form-control selectbox"
                                    menuPlacement="auto"
                                    options={ClassList}
                                    isMulti
                                    value={ClassList?.filter((d) => values.classIds?.includes(d.value)) || []}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions?.map((item) => item.value) || [];
                                        setFieldValue("classIds", selectedValues);
                                    }}
                                    isClearable
                                />
                                <Label className="form-label" htmlFor="classIds">
                                    Class
                                </Label>
                                {errors.classIds && touched.classIds && (
                                    <div className="text-danger mt-1">{errors.classIds}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-3">
                        <Button color="secondary" type="button" onClick={onCancel} className="me-2">
                            Cancel
                        </Button>
                        <Button color="success" disabled={ !values.year || isSubmitting
                        } type="button" onClick={() => syncRebateClass(values)} className="me-2">
                            Sync Rebate class
                        </Button>
                        <Button
                            color="primary"
                            type="submit"
                            disabled={
                                isSubmitting ||
                                !isValid ||
                                !values.year ||
                                !values.classIds?.length ||
                                !values.quarter
                            }
                        >
                            Sync Rebates
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
}

